import React from 'react';
import { news } from '../../models/content';

function formatNewsDate(iso) {
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
  } catch {
    return '';
  }
}

export default function V2NewsPage() {
  return (
    <main>
      <section className="page-hero">
        <div className="wrap">
          <span className="v2-badge">
            <span className="dot" />
            {news.heroBadge}
          </span>
          <h1>
            {news.heroTitle.map((p, i) =>
              typeof p === 'string' ? (
                <React.Fragment key={i}>{p}</React.Fragment>
              ) : (
                <span key={i} className="it">
                  {p.it}
                </span>
              )
            )}
          </h1>
          <p className="sub">{news.heroSub}</p>
        </div>
      </section>

      <section>
        <div className="wrap">
          <div className="news-grid">
            {news.items.map((item, index) => {
              const headingId = `news-heading-${index}`;
              const linkId = `read-more-${index}`;
              return (
                <article className="news-card" key={item.url}>
                  <div
                    className="thumb"
                    style={{
                      backgroundImage: item.image ? `url("${item.image}")` : undefined,
                      backgroundColor: item.image ? undefined : 'var(--p200)',
                    }}
                  />
                  <div className="pad">
                    <span className="date">{formatNewsDate(item.time)}</span>
                    <h2 id={headingId}>{item.heading}</h2>
                    {item.description ? <p className="summary">{item.description}</p> : null}
                    <a
                      id={linkId}
                      className="more"
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-labelledby={`${linkId} ${headingId}`}
                    >
                      Read More <span aria-hidden="true">→</span>
                    </a>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}

